"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.tryit = exports.sleep = exports.retry = exports.parallel = exports.AggregateError = exports.defer = exports.map = exports.reduce = void 0;
var array_1 = require("./array");
/**
 * An async reduce function. Works like the
 * built-in Array.reduce function but handles
 * an async reducer function
 */
var reduce = function (array, asyncReducer, initValue) { return __awaiter(void 0, void 0, void 0, function () {
    var initProvided, iter, value, _i, iter_1, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initProvided = initValue !== undefined;
                if (!initProvided && (array === null || array === void 0 ? void 0 : array.length) < 1) {
                    throw new Error('Cannot reduce empty array with no init value');
                }
                iter = initProvided ? array : array.slice(1);
                value = initProvided ? initValue : array[0];
                _i = 0, iter_1 = iter;
                _a.label = 1;
            case 1:
                if (!(_i < iter_1.length)) return [3 /*break*/, 4];
                item = iter_1[_i];
                return [4 /*yield*/, asyncReducer(value, item)];
            case 2:
                value = _a.sent();
                _a.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, value];
        }
    });
}); };
exports.reduce = reduce;
/**
 * An async map function. Works like the
 * built-in Array.map function but handles
 * an async mapper function
 */
var map = function (array, asyncMapFunc) { return __awaiter(void 0, void 0, void 0, function () {
    var result, _i, array_2, value, newValue;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                result = [];
                _i = 0, array_2 = array;
                _a.label = 1;
            case 1:
                if (!(_i < array_2.length)) return [3 /*break*/, 4];
                value = array_2[_i];
                return [4 /*yield*/, asyncMapFunc(value)];
            case 2:
                newValue = _a.sent();
                result.push(newValue);
                _a.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, result];
        }
    });
}); };
exports.map = map;
/**
 * Useful when for script like things where cleanup
 * should be done on fail or sucess no matter.
 *
 * You can call defer many times to register many
 * defered functions that will all be called when
 * the function exits in any state.
 */
var defer = function (func) { return __awaiter(void 0, void 0, void 0, function () {
    var callbacks, register, _a, err, response, _i, callbacks_1, _b, fn, rethrow, rethrown;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                callbacks = [];
                register = function (fn, options) {
                    var _a;
                    return callbacks.push({
                        fn: fn,
                        rethrow: (_a = options === null || options === void 0 ? void 0 : options.rethrow) !== null && _a !== void 0 ? _a : false
                    });
                };
                return [4 /*yield*/, (0, exports.tryit)(func)(register)];
            case 1:
                _a = _c.sent(), err = _a[0], response = _a[1];
                _i = 0, callbacks_1 = callbacks;
                _c.label = 2;
            case 2:
                if (!(_i < callbacks_1.length)) return [3 /*break*/, 5];
                _b = callbacks_1[_i], fn = _b.fn, rethrow = _b.rethrow;
                return [4 /*yield*/, (0, exports.tryit)(fn)(err)];
            case 3:
                rethrown = (_c.sent())[0];
                if (rethrow)
                    throw rethrown;
                _c.label = 4;
            case 4:
                _i++;
                return [3 /*break*/, 2];
            case 5:
                if (err)
                    throw err;
                return [2 /*return*/, response];
        }
    });
}); };
exports.defer = defer;
/**
 * Support for the built-in AggregateError
 * is still new. Node <= 14 doesn't have it
 * so patching here.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError#browser_compatibility
 */
var AggregateError = /** @class */ (function (_super) {
    __extends(AggregateError, _super);
    function AggregateError(errors) {
        var _this = _super.call(this) || this;
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}(Error));
exports.AggregateError = AggregateError;
/**
 * Executes many async functions in parallel. Returns the
 * results from all functions as an array. After all functions
 * have resolved, if any errors were thrown, they are rethrown
 * in an instance of AggregateError
 */
var parallel = function (limit, array, func) { return __awaiter(void 0, void 0, void 0, function () {
    var work, processor, queues, itemResults, _a, errors, results;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                work = array.map(function (item, index) { return ({
                    index: index,
                    item: item
                }); });
                processor = function (res) { return __awaiter(void 0, void 0, void 0, function () {
                    var results, next, _a, error, result;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                results = [];
                                _b.label = 1;
                            case 1:
                                if (!true) return [3 /*break*/, 3];
                                next = work.pop();
                                if (!next)
                                    return [2 /*return*/, res(results)];
                                return [4 /*yield*/, (0, exports.tryit)(func)(next.item)];
                            case 2:
                                _a = _b.sent(), error = _a[0], result = _a[1];
                                results.push({
                                    error: error,
                                    result: result,
                                    index: next.index
                                });
                                return [3 /*break*/, 1];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); };
                queues = (0, array_1.list)(1, limit).map(function () { return new Promise(processor); });
                return [4 /*yield*/, Promise.all(queues)];
            case 1:
                itemResults = (_b.sent());
                _a = (0, array_1.fork)((0, array_1.sort)(itemResults.flat(), function (r) { return r.index; }), function (x) { return !!x.error; }), errors = _a[0], results = _a[1];
                if (errors.length > 0) {
                    throw new AggregateError(errors.map(function (error) { return error.error; }));
                }
                return [2 /*return*/, results.map(function (r) { return r.result; })];
        }
    });
}); };
exports.parallel = parallel;
/**
 * Retries the given function the specified number
 * of times.
 */
var retry = function (options, func) { return __awaiter(void 0, void 0, void 0, function () {
    var times, delay, backoff, _i, _a, i, _b, err, result;
    var _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                times = (_c = options === null || options === void 0 ? void 0 : options.times) !== null && _c !== void 0 ? _c : 3;
                delay = options === null || options === void 0 ? void 0 : options.delay;
                backoff = (_d = options === null || options === void 0 ? void 0 : options.backoff) !== null && _d !== void 0 ? _d : null;
                _i = 0, _a = (0, array_1.list)(1, times);
                _e.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 7];
                i = _a[_i];
                return [4 /*yield*/, (0, exports.tryit)(func)(function (err) {
                        throw { _exited: err };
                    })];
            case 2:
                _b = (_e.sent()), err = _b[0], result = _b[1];
                if (!err)
                    return [2 /*return*/, result];
                if (err._exited)
                    throw err._exited;
                if (i === times)
                    throw err;
                if (!delay) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, exports.sleep)(delay)];
            case 3:
                _e.sent();
                _e.label = 4;
            case 4:
                if (!backoff) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, exports.sleep)(backoff(i))];
            case 5:
                _e.sent();
                _e.label = 6;
            case 6:
                _i++;
                return [3 /*break*/, 1];
            case 7: return [2 /*return*/];
        }
    });
}); };
exports.retry = retry;
/**
 * Async wait
 */
var sleep = function (milliseconds) {
    return new Promise(function (res) { return setTimeout(res, milliseconds); });
};
exports.sleep = sleep;
/**
 * A helper to try an async function without forking
 * the control flow. Returns an error first callback _like_
 * array response as [Error, result]
 */
var tryit = function (func) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = [null];
                        return [4 /*yield*/, func.apply(void 0, args)];
                    case 1: return [2 /*return*/, _a.concat([_b.sent()])];
                    case 2:
                        err_1 = _b.sent();
                        return [2 /*return*/, [err_1, null]];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
};
exports.tryit = tryit;
//# sourceMappingURL=async.js.map